export class CodaBoxConfig {
	Connected: boolean = false;
	StartDate: string = "";
	FetchCoda: boolean = true;
	FetchSoda: boolean = true;
	FetchPurchaseInvoices: boolean = false;
	FetchSalesInvoices: boolean = false;

	public constructor(data?: any) {
		if (!data) return;
		this.Connected = data.Connected || false;
		this.StartDate = data.StartDate || "";
		this.FetchCoda = data.FetchCoda === undefined ? true : data.FetchCoda;
		this.FetchSoda = data.FetchSoda === undefined ? true : data.FetchSoda;
		this.FetchPurchaseInvoices = data.FetchPurchaseInvoices || false;
		this.FetchSalesInvoices = data.FetchSalesInvoices || false;
	}

	public getJSON() {
		return {
			StartDate: this.StartDate,
			FetchCoda: this.FetchCoda,
			FetchSoda: this.FetchSoda,
			FetchPurchaseInvoices: this.FetchPurchaseInvoices,
			FetchSalesInvoices: this.FetchSalesInvoices,
		};
	}
}
